export let router = null;
import Vue from "vue";
import Router from "vue-router";
import { store } from "../store";
import routeMapper from "./routeMapper";
import * as mutationTypes from "../store/mutation-types";
import appConfig from "../appconfig";
import FeatureToggleProvider from "../providers/FeatureToggleProvider";
import { setI18nInRouter } from "../helper/LocalizationHelper";
// using exact routes needed for mobile / browser set up in webpack
import typeRouter from "@bifrost/routes";

const adminPrivateRoutes = routeMapper.adminPrivateRoutes;
const adminPublicRoutes = routeMapper.adminPublicRoutes;
const productionForbiddenRoutes = routeMapper.productionForbiddenRoutes;

// import {ApmVuePlugin} from "@elastic/apm-rum-vue";
import { ApmVuePlugin } from "../helper/ApmVuePlugin";
import {ApmHelper} from "../domains2/libraries/ApmHelper";
import {flowSetting} from "../libraries/utils";

Vue.use(Router);

router = new Router({
	mode: appConfig.mobile.isMobileApp() ? "hash" : "history",
	routes: typeRouter.routes,
	scrollBehavior() {
		return {
			x: 0,
			y: 0
		};
	}
});
(()=>{
	const apmRumConfig = appConfig.apmRumConfig[appConfig.getBusinessModelId()];
	if(apmRumConfig && apmRumConfig.enabled) {
		const serverUrl = `${apmRumConfig.protocol}://${apmRumConfig.hostname}:${apmRumConfig.port}`;
		const {serviceName, serviceVersion, transactionSampleRate, flushInterval, centralConfig} = apmRumConfig;
		const clientTraceId = appConfig.clientTraceId();
		const environment = `${appConfig.envPrefix()}-env`;
		Vue.use(ApmVuePlugin, {
			router,
			config: {
				serviceName,
				serverUrl,
				environment,
				serviceVersion,
				transactionSampleRate,
				flushInterval,
				centralConfig
			}
		});
		Vue.prototype.$apm.setUserContext({id: clientTraceId});

		// APM RUM Config
		const MAX_TRANSACTION_NAME_LENGTH = 100;
		Vue.prototype.$apm.observe("transaction:end", (transaction) => {
			if (transaction.type === "user-interaction") {
				if (transaction.name.length > MAX_TRANSACTION_NAME_LENGTH) transaction.name = transaction.name.substring(0, MAX_TRANSACTION_NAME_LENGTH);
				// transaction.name = "good name for div click";
			}

			// Handle route-change transactions
			if (transaction.type === "route-change") {
				// Get the actual URL from transaction context
				const url = transaction && transaction.context && transaction.context.page && transaction.context.page.url;
				if (url) {
					try {
						const urlPath = new URL(url).pathname;
						// Replace parameterized routes with actual values - avoid grouping to "/category/:categoryId/"
						if (transaction.name === "/category/:categoryId/" || transaction.name === "/category/:categoryId") {
							const categoryMatch = urlPath.match(/\/category\/(\d+)\/?/);
							if (categoryMatch) {
								const categoryId = categoryMatch[1];
								transaction.name = `/category/${categoryId}`;
							}
						}
					} catch (e) {
						// eslint-disable-next-line no-console
						console.warn("APM: Could not parse URL for transaction naming", e);
					}
				}
			}
		});

		ApmHelper.setApm(Vue.prototype.$apm, {
			tenantId: appConfig.tenantConfig.tenantId,
			channel: appConfig.channelAlias()
		});
	}
})();


const CATALOG_PATHS = {
	"category": true,
	"product": true
};

router.beforeEach((to, from, next) => {
	(async() => {
		// execute before each from templates if any

		if (typeof typeRouter.beforeEach === "function") {
			await typeRouter.beforeEach(to, from, next);
		}

		// If not catalog page, load initial data
		const split = to.path.split("/");
		if (!(to.path === "/" || (split && split.length >= 2 && CATALOG_PATHS[split[1]]))) {
			const serverDataPromise = store.dispatch("cacheServerData", {});
			const featureTogglePromise = FeatureToggleProvider.getFeatureTogglesAsPromise();

			await Promise.all([
				serverDataPromise,
				featureTogglePromise,
				setI18nInRouter(store, to.name)
			]);
		}

		function getNextRoute() {
			// check for admin
			const isAdminPrivate = adminPrivateRoutes.includes(to.name);
			const isAdminPublic = adminPublicRoutes.includes(to.name);
			if (isAdminPrivate || isAdminPublic) {
				flowSetting.set("admin");
				const isForbiddenOnProduction = productionForbiddenRoutes.includes(to.name);

				if (isForbiddenOnProduction && store.getters.envPrefix === "p") {
					return "/admin";
				}

				if (isAdminPrivate && !store.getters.jwtToken) {
					store.commit(mutationTypes.ADMIN_SET_REDIRECT_URL, to.fullPath);
					return "/admin/login";
				}

				if (isAdminPublic && store.getters.jwtToken) {
					return "/admin";
				}
			} else {
				flowSetting.set("shop");
				// check for shop
				if (appConfig.tenantConfig.forceShopSelection) {
					// check if shop is selected
					const isShopSelectionRoute = to.name === routeMapper.routeNames.shopSelection;
					if (store.getters.globalSelectedShop === null && !isShopSelectionRoute) {
						store.commit(mutationTypes.SET_REDIRECT_URL, to.fullPath);
						return "/shop-selection";
					}
				}
			}

			return false;
		}

		// check if needed to redirect
		const route = getNextRoute();
		if (route) {
			next(route);
		} else {
			next();
		}
	})();
});

export default router;
